export default {
  'cgv-print':
    'Les informations ci-après sont imprimables en tout temps grâce aux raccourcis clavier "CTRL + P" sur Windows, "Cmd + P" sur Mac et le bouton "Partager" du navigateur sur mobile.',
};
